function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.922 2.409A2.32 2.32 0 0017.295.772C15.85.375 10.073.375 10.073.375s-5.777 0-7.222.382A2.367 2.367 0 001.224 2.41C.844 3.86.844 6.874.844 6.874s0 3.028.38 4.465a2.32 2.32 0 001.627 1.637c1.46.397 7.222.397 7.222.397s5.777 0 7.222-.382a2.32 2.32 0 001.627-1.636c.38-1.453.38-4.466.38-4.466s.015-3.028-.38-4.48z",
  fill: "red"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.037 6.875L8.233 4.092V9.66l4.804-2.784z",
  fill: "#fff"
});

function SvgSocialYoutube(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

SvgSocialYoutube.defaultProps = {
  color: "#000",
  title: "Social Youtube"
};
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJyZWFjdC1jb21wb25lbnRzL2ljb25zL1NvY2lhbFlvdXR1YmUtMjI5OTA5ODJkZGYyNWQ0ODRjMTc1YWU4MTdmN2RjNDQuc3ZnIjs=";
export { SvgSocialYoutube as ReactComponent };